import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SNModalService } from '@web-services/modal/snModal.service';
import { ListItem } from '@models/models';
import { ConfirmGeneralModalComponent } from '@web-components/common/confirm-general-modal/confirm-general-modal.component';
import { PlatformLocation } from '@angular/common';

@Component({
	selector: 'save-as-template',
	template: require('./save-as-template-modal.component.html'),
	styles: [require('./save-as-template-modal.component.scss')]
})
export class SaveAsTemplateModalComponent {
	@Input() templateList: Array<ListItem>;
	@Input() detailedDescription: string;
	@Input() templateTypeName: string;
	@Input() templateNameTitle: string;
	@Input() btnDisable: boolean;
	@Input() breadcrumbsText: string;

	selectedTemplate: ListItem = null;

	constructor(
		private activeModal: NgbActiveModal,
		private modalService: SNModalService,
		private location: PlatformLocation
	) {
		location.onPopState(() => this.onDismiss());
	}

	onDismiss(): void {
		this.modalService.setModalData({ action: 'CLOSE', props: null });
	}

	overwriteTemplate(): void {
		if (!this.selectedTemplate) {
			this.modalService.setModalData({
				action: 'OVERWRITE',
				props: this.selectedTemplate
			});
			return;
		}

		this.confirmTemplateOverwrite().then((action: string): void => {
			this.modalService.setModalData({
				action,
				props: this.selectedTemplate
			});
		});
	}

	saveNewTemplate(): void {
		this.modalService.setModalData({
			action: 'SAVE',
			props: null
		});
	}

	templateChoose(event: ListItem): void {
		this.selectedTemplate = event;
	}

	private confirmTemplateOverwrite(): Promise<string> {
		return new Promise((resolve, reject): void => {
			const modal = this.modalService.openModal(ConfirmGeneralModalComponent, {
				windowClass: 'ng-bootstrap-modal-small modal-visible modal-narrow'
			});
			modal.componentInstance.text = `The ${
				this.templateTypeName
			} template <b>${
				this.selectedTemplate.name
			}</b> will be overwritten and updated. Are you sure?`;
			modal.componentInstance.htmlText = true;
			modal.componentInstance.buttons = [
				{
					text: 'Yes',
					action: 'OVERWRITE',
					color: 'success',
					size: 'lg'
				},
				{
					text: 'No',
					action: 'CLOSE',
					color: 'default',
					size: 'lg'
				}
			];
			modal.result
				.then((action: string): void => {
					if (action === 'OVERWRITE') {
						resolve(action);
					}
				})
				.catch(reject);
		});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/quotes/modals/save-as-template-modal/save-as-template-modal.component.ts